export default "__VITE_ASSET__7ea8c8f6__"